import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import weekDays from 'components/CompanyWorkingDays/weekDays';
import { useTranslation } from 'react-i18next';
import useScheduleCalendarContext from 'components/ScheduleCalendar/context/useScheduleCalendarContext';
import getScheduleShift from './getScheduleShift';

export default function DayScaleCellComponent({
  startDate,
  today,
}: WeekView.DayScaleCellProps) {
  const { t } = useTranslation();
  const { scheduleRanges } = useScheduleCalendarContext();

  const startDateDay = startDate.getDate();
  const day = startDate.getDay();

  const workingDay = weekDays.find((dayItem) => dayItem.value === day);
  const workingDayLabel = workingDay ? t(workingDay.abbreviation) : '';
  const scheduleHours = getScheduleShift({ scheduleRanges, day });

  return (
    <Box
      component="td"
      sx={{
        borderRight: '0.1rem solid',
        borderColor: 'border.main',
      }}
    >
      <Stack alignItems="center" px={1} py={2}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ userSelect: 'none' }}
        >
          {workingDayLabel}
        </Typography>
        <Typography
          variant="h6"
          color={today ? 'primary.main' : 'text.primary'}
          sx={{ userSelect: 'none' }}
        >
          {startDateDay}
        </Typography>
        <Box mt={1}>
          {scheduleHours ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ userSelect: 'none' }}
            >
              {scheduleHours.timeFrom.hours}
              <sup>{scheduleHours.timeFrom.minutes}</sup>&nbsp;-&nbsp;
              {scheduleHours.timeTo.hours}
              <sup>{scheduleHours.timeTo.minutes}</sup>
            </Typography>
          ) : (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ userSelect: 'none' }}
            >
              {t('project_tracking.non_working')}
            </Typography>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
